type ConnectorError = { code: string; data?: unknown };

type MessageKey =
  | 'error.sms_daily_limit'
  | 'error.sms_hourly_limit'
  | 'error.verification_too_frequent'
  | 'error.verification_service_unavailable';

const smsMessages = new Map<string, MessageKey>([
  ['LimitExceeded.PhoneNumberDailyLimit', 'error.sms_daily_limit'],
  ['LimitExceeded.PhoneNumberSameContentDailyLimit', 'error.sms_daily_limit'],
  ['LimitExceeded.PhoneNumberOneHourLimit', 'error.sms_hourly_limit'],
  ['LimitExceeded.PhoneNumberThirtySecondLimit', 'error.verification_too_frequent'],
  ['LimitExceeded.DeliveryFrequencyLimit', 'error.verification_too_frequent'],
]);

function providerCode(data: unknown): string | undefined {
  if (typeof data === 'string') {
    return /^([A-Za-z]+\.[A-Za-z]+)(?=:|$)/.exec(data)?.[1];
  }

  if (!data || typeof data !== 'object') {
    return;
  }

  if ('Code' in data && typeof data.Code === 'string') {
    return data.Code;
  }

  if ('code' in data && typeof data.code === 'string') {
    return data.code;
  }

  return 'message' in data && typeof data.message === 'string'
    ? providerCode(data.message)
    : undefined;
}

/** Present connector failures without rendering vendor details or request IDs. */
export function connectorErrorMessage(error: ConnectorError): MessageKey | undefined {
  if (!error.code.startsWith('connector.')) {
    return;
  }

  if (error.code === 'connector.rate_limit_exceeded') {
    return 'error.verification_too_frequent';
  }

  return (
    smsMessages.get(providerCode(error.data) ?? '') ?? 'error.verification_service_unavailable'
  );
}
